export default {
  login: {
    title: 'Redirecting...',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/auth/login.js